export default "__VITE_ASSET__Brnuj3Sh__"